import { render, staticRenderFns } from "./KezModal.vue?vue&type=template&id=47645b66&"
import script from "./KezModal.vue?vue&type=script&lang=js&"
export * from "./KezModal.vue?vue&type=script&lang=js&"
import style0 from "./KezModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KezModal.vue"
export default component.exports